import { render, staticRenderFns } from "./Esqueceu.vue?vue&type=template&id=7091b901"
import script from "./Esqueceu.vue?vue&type=script&lang=js"
export * from "./Esqueceu.vue?vue&type=script&lang=js"
import style0 from "./Esqueceu.vue?vue&type=style&index=0&id=7091b901&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports